<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'

import Card from '@/components/ui/Card.vue'
import ContentBody from '@/components/ui/ContentBody.vue'
import ContentHeader from '@/components/ui/ContentHeader.vue'
import Breadcrumb from '@/components/ui/breadcrumb/Breadcrumb.vue'
import Tag from '@/components/ui/tag/Tag.vue'
import { RouterLink } from 'vue-router'
import i18n from '../VueI18n'

const step = computed(() => {
	return crumbs.value.length - 1
})

const { crumbs, children, name } = useLayoutCrud()

function useLayoutCrud() {
	const { currentRoute } = useRouter()
	const { name, path } = currentRoute

	const crumbs = computed(() => {
		const pathArray = path.split('/').filter((crumb) => crumb != '')
		pathArray.splice(pathArray.length - 1, 1, name)

		return pathArray.map((crumb, index) => {
			return {
				name: crumb
					.replace('Inventario', 'Inventário')
					.replace('inventario', 'inventário')
					.replace('configuracoes', 'configurações')
					.replace('Configuracoes', 'configurações'),
				step: index,
			}
		})
	})

	const children = computed(() => {
		return [
			{ name: i18n.t('forestInventory'), path: '/configuracoes/aplicativo/inventario' },
			{ name: i18n.t('logging'), path: '/configuracoes/aplicativo/cubagem' },
			// { name: "Inventário Qualidade", path: "/configuracoes/aplicativo/qualidade" },
			{ name: i18n.t('stackInventory'), path: '/configuracoes/aplicativo/pilha' },
		]
	})

	return { crumbs, children, name, currentRoute }
}
</script>

<template>
	<div class="flex justify-center flex-col">
		<ContentHeader>
			<Breadcrumb
				v-model="step"
				:icon="false"
				:crumbs="crumbs"
				class="breadcrumb__internal flex justify-start"
			/>
		</ContentHeader>
		<ContentBody>
			<Card class="card">
				<div class="flex gap-4 justify-end">
					<RouterLink
						v-for="child in children"
						:key="child.name"
						:to="child.path"
					>
						<Tag
							class="py-0.5"
							:disabled="child.disabled"
							:active="name === child.name"
						>
							{{ child.name }}
						</Tag>
					</RouterLink>
				</div>
				<slot />
			</Card>
		</ContentBody>
	</div>
</template>

<style scoped>
.card {
	@apply px-20 py-8 bg-white w-full;
}

.active {
	@apply border-blue-600;
}
</style>
